export function log(...args: any[]) {
    try {
        const log = console?.log;
        return log && log.call(console, ...args);
    } catch (e) {
        return;
    }
}

export function warn(...args: any[]) {
    try {
        const warn = console?.warn;
        return warn && warn.call(console, ...args);
    } catch (e) {
        return;
    }
}
const sdkName: string = '__SDK_NAME__';
export function error(...args: any[]) {
    try {
        const error = sdkName === 'webLogger_krn' ? console?.log : console?.error;
        return error && error.call(console, ...args);
    } catch (e) {
        return;
    }
}
